import { gql } from "@apollo/client";

/**
 * Mutation to set the user's active persona via the care-management-gql
 * `connectSetCurrentPersona` proxy resolver (ACT-1256 D12, care-mgmt PR #35173).
 *
 * On success the caller refetches CURRENT_USER (via refetchQueries) so
 * useCurrentUser() reflects the new persona, modules, and permissions. The
 * mutation selection does NOT include `modules`, `role`, or `permissions` — it
 * returns only { id, currentPersona { code displayName }, personas }. The full
 * user shape (including module grants) comes from the CURRENT_USER refetch.
 */
export const PERSONA_CHANGE = gql`
  mutation PersonaChange($personaCode: String!) {
    connectSetCurrentPersona(personaCode: $personaCode) {
      id
      currentPersona {
        code
        displayName
      }
      personas {
        code
        displayName
      }
    }
  }
`;

export interface PersonaChangeVars {
  personaCode: string;
}

export interface PersonaChangeResult {
  connectSetCurrentPersona: {
    id: string;
    currentPersona: {
      code: string;
      displayName: string;
    } | null;
    personas: Array<{
      code: string;
      displayName: string;
    }>;
  } | null;
}
